<template>
  <kst-page-export-details
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_Init"
    />

    <kst-check disabled
      v-model="userData.WithDetails"
      :label="Info.Export.Details.Excel.Option.Details"
    />
    <template v-if="access.Invoice_Act_List">
      <kst-check
        v-model="userData.WithInvoiceList"
        :label="Info.Export.Details.Excel.Option.InvoiceList"
      />
    </template>
  </kst-page-export-details>
</template>

<script>
import Info from "../SlrcInfo.js";
import Model from "../SlrcModel.js";
import Services from "../../../services/Api/SalesRecapServices.js";

import Export from "./SlrcExD_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    access: {},
    userData: {
      ID: null,
      WithDetails: true,
      WithInvoiceList: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit(id) {
      this.userData.ID = id;

      this.access = this.$kst.Access.create(Model.Access);
      this.userData.WithInvoiceList = this.access.Invoice_Act_List;
    },

    handleExport(loadExport) {
      const config = Services.getExportDetails(this.userData.ID);
      loadExport(config, this.handleExport_Success);
    },
    handleExport_Success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** custom ***/

    handleExport_Init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    }
  }
}
</script>